const state = ({
  graphIds: null,
})

const getters = {
  getGraphIds: state => state.graphIds
}

const actions = {
  graphIds ({ commit }, payload) {
    commit('setGraphIds', payload)
  }
}

const mutations = {
  setGraphIds: (state, payload) => {
    state.graphIds = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}